export const ECHELLE_DESCRIPTIONS: Record<string, string> = {
  "Charge de travail": "quantité de travail à accomplir",
  "Rythme de travail": "vitesse à laquelle les tâches doivent être réalisées",
  "Exigences cognitives":
    "demandes faisant appel aux capacités cognitives de la personne",
  Prévisibilité: "moyens permettant d'éviter l'incertitude et l'insécurité",
  Reconnaissance:
    "valorisation par le management des efforts fournis au travail",
  "Justice organisationnelle": "équité dans le traitement des salariés",
  "Clarté des rôles":
    "compréhension qu'a la personne de sa place dans l'organisation (contenu des tâches, attentes à satisfaire et responsabilités qui lui incombent)",
  "Conflit de valeurs":
    "devoir agir en opposition avec ses valeurs professionnelles, sociales ou personnelles",
  "Qualité de leadership du responsable hiérarchique":
    "manière dont le supérieur hiérarchique direct exerce son autorité",
  "Soutien de la part du responsable hiérarchique":
    "perception qu'a la personne de la possibilité d'obtenir un soutien de son supérieur direct en cas de besoin",
  "Confiance entre les salariés et le management":
    "capacité des salariés à faire confiance au management et réciproquement",
  "Confiance et coopération entre collègues":
    "qualité des relations entre collègues et capacité à travailler ensemble",
  "Soutien de la part des collègues":
    "perception qu'a la personne de la possibilité d'obtenir un soutien de ses collègues en cas de besoin",
  "Marge de manœuvre":
    "degré auquel la personne peut influer sur différents aspects de son travail",
  "Possibilités d'épanouissement":
    "caractère stimulant des tâches réalisées et opportunités d'apprentissage qu'elles offrent, permettant un développement non seulement professionnel mais aussi personnel",
  "Santé auto évaluée":
    "perception par la personne de son état de santé général",
  Stress: "niveau de fréquence de stress ressenti par la personne",
  Epuisement:
    "niveau de fréquence d'épuisement physique et mental ressenti par la personne",
  "Exigences émotionnelles":
    "demandes faisant appel aux capacités émotionnelles de la personne",
  "Conciliation entre vie privée et vie professionnelle":
    "répercussions possibles du travail sur la vie privée ou familiale",
  "Insécurité professionnelle":
    "sécurité du statut d'emploi (risque de licenciement, certitude de retrouver un emploi)",
  "Sens du travail": "sens et importance perçus du travail réalisé",
  "Engagement dans l'entreprise":
    "degré auquel la personne se sent attaché à son entreprise/organisation",
  "Satisfaction au travail": "satisfaction ressentie à l'égard de son travail",
};

export const DOMAIN_CLASS_BOUNDS: Record<string, [number, number, number, number]> = {
  "Contraintes quantitatives": [12, 16, 21, 25],
  "Organisation et Management": [25, 34, 46, 55],
  "Relations entre collègues": [7, 10, 15, 18],
  Autonomie: [7, 9, 13, 16],
  "Santé et Bien-être": [20, 27, 37, 43],
  "Vécu professionnel": [6, 9, 13, 16],
};

/**
 * Un domaine COPSOQ III = une CATÉGORIE, pas un état : ces teintes distinguent,
 * elles n'expriment ni progression ni gravité. D'où l'échelle `--categorie-*`
 * et non `--etat-*` (décision de la PR 0C-6).
 */
export const DOMAINS_CONFIG = [
  {
    name: "Contraintes quantitatives",
    color: "var(--categorie-1)",
    bg: "bg-categorie-1-surface",
    border: "border-categorie-1-trait",
    text: "text-categorie-1-contenu",
  },
  {
    name: "Organisation et Management",
    color: "var(--categorie-2)",
    bg: "bg-categorie-2-surface",
    border: "border-categorie-2-trait",
    text: "text-categorie-2-contenu",
  },
  {
    name: "Relations entre collègues",
    color: "var(--categorie-3)",
    bg: "bg-categorie-3-surface",
    border: "border-categorie-3-trait",
    text: "text-categorie-3-contenu",
  },
  {
    name: "Autonomie",
    color: "var(--categorie-4)",
    bg: "bg-categorie-4-surface",
    border: "border-categorie-4-trait",
    text: "text-categorie-4-contenu",
  },
  {
    name: "Santé et Bien-être",
    color: "var(--categorie-5)",
    bg: "bg-categorie-5-surface",
    border: "border-categorie-5-trait",
    text: "text-categorie-5-contenu",
  },
  {
    name: "Vécu professionnel",
    color: "var(--categorie-6)",
    bg: "bg-categorie-6-surface",
    border: "border-categorie-6-trait",
    text: "text-categorie-6-contenu",
  },
] as const;

export const DIMENSIONS_ORDER: Record<string, string[]> = {
  "Contraintes quantitatives": [
    "Charge de travail",
    "Rythme de travail",
    "Exigences cognitives",
  ],
  "Organisation et Management": [
    "Prévisibilité",
    "Reconnaissance",
    "Justice organisationnelle",
    "Clarté des rôles",
    "Conflit de valeurs",
    "Qualité de leadership du responsable hiérarchique",
    "Soutien de la part du responsable hiérarchique",
    "Confiance entre les salariés et le management",
  ],
  "Relations entre collègues": [
    "Confiance et coopération entre collègues",
    "Soutien de la part des collègues",
  ],
  Autonomie: ["Marge de manœuvre", "Possibilités d'épanouissement"],
  "Santé et Bien-être": [
    "Santé auto évaluée",
    "Stress",
    "Epuisement",
    "Exigences émotionnelles",
    "Conciliation entre vie privée et vie professionnelle",
    "Insécurité professionnelle",
  ],
  "Vécu professionnel": [
    "Sens du travail",
    "Engagement dans l'entreprise",
    "Satisfaction au travail",
  ],
};
